/**
 * Skeleton da Clínica — header padrão + catálogo de procedimentos + backup.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Catálogo de procedimentos */}
      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <div className="mb-4 flex items-center justify-between">
          <div className="space-y-2">
            <div className="h-4 w-48 rounded bg-slate-200" />
            <div className="h-3 w-80 max-w-full rounded bg-slate-100" />
          </div>
          <div className="h-8 w-40 rounded-lg bg-slate-100" />
        </div>
        <div className="h-3 w-24 rounded bg-slate-100" />
        <div className="mt-2 overflow-hidden rounded-xl border border-slate-200">
          {[0, 1, 2].map((r) => (
            <div
              key={r}
              className="flex items-center justify-between border-b border-slate-100 px-3 py-2.5 last:border-0"
            >
              <div className="space-y-1.5">
                <div className="h-4 w-40 rounded bg-slate-200" />
                <div className="h-3 w-24 rounded bg-slate-100" />
              </div>
              <div className="h-4 w-20 rounded bg-slate-100" />
            </div>
          ))}
        </div>
      </div>

      {/* Backup */}
      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <div className="mb-3 h-4 w-36 rounded bg-slate-200" />
        <div className="mb-4 h-3 w-full max-w-2xl rounded bg-slate-100" />
        <div className="h-9 w-52 rounded-lg bg-slate-100" />
      </div>
    </div>
  );
}
